import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

function RegistrationCookieCleaner() {
  const location = useLocation();

  // Очистка registration cookies при уходе со страницы регистрации.
  // Раньше здесь также стиралась Cookies.remove('auth_token') - теперь
  // кука httpOnly, фронт её не видит и не может удалить. Оставшаяся
  // (уже невидимая для JS) кука не страшна сама по себе - защиту от
  // недоделанной регистрации нужно обеспечивать на бэкенде, если это
  // всё ещё нужно.
  useEffect(() => {
    if (
      Cookies.get('is_registration') === 'true' &&
      !location.pathname.startsWith('/registration')
    ) {
      Cookies.remove('is_registration');
    }
  }, [location.pathname]);

  return null;
}

export default RegistrationCookieCleaner;
